import apiClient from './api_client_requests';

export default async (payload) => {
    const promotionId = payload?.promotion_id;
    const view = payload?.view ?? 'approved';

    let result = await apiClient.apiMethod({
        method: 'GetDrawings',
        args: {
            ...payload,
        },
    });

    return {
        promotionId: result?.promotion_id ?? promotionId,
        drawings: result?.drawings ?? [],
        view: view,
    };
};
